module.exports = __webpack_public_path__ + "img/swiper_4.b151d661.png";